var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 7,
    transform: "matrix(1 0 0 -1 0 46)",
    fill: "#0080FF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 24.9557H23.9583V32.2474C23.9583 32.6342 23.8047 33.0051 23.5312 33.2786C23.2577 33.5521 22.8868 33.7057 22.5 33.7057C22.1132 33.7057 21.7423 33.5521 21.4688 33.2786C21.1953 33.0051 21.0417 32.6342 21.0417 32.2474V24.9557H13.75C13.3632 24.9557 12.9923 24.8021 12.7188 24.5286C12.4453 24.2551 12.2917 23.8842 12.2917 23.4974C12.2917 23.1106 12.4453 22.7397 12.7188 22.4662C12.9923 22.1927 13.3632 22.0391 13.75 22.0391H21.0417V14.7474C21.0417 14.3606 21.1953 13.9897 21.4688 13.7162C21.7423 13.4427 22.1132 13.2891 22.5 13.2891C22.8868 13.2891 23.2577 13.4427 23.5312 13.7162C23.8047 13.9897 23.9583 14.3606 23.9583 14.7474V22.0391H31.25C31.6368 22.0391 32.0077 22.1927 32.2812 22.4662C32.5547 22.7397 32.7083 23.1106 32.7083 23.4974C32.7083 23.8842 32.5547 24.2551 32.2812 24.5286C32.0077 24.8021 31.6368 24.9557 31.25 24.9557Z",
    fill: "#0080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/addButton.061dcf18f4e0c5920f7beab79a87e791.svg";
export { ForwardRef as ReactComponent };